// extracted by css-extract-rspack-plugin
export default {"large":"DIsrTt","wide":"t5sBv0","small":"kbHxnu"};